"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = getStyle;

var _camelizeStyleName = _interopRequireDefault(require("./utils/camelizeStyleName"));

var _getComputedStyle = _interopRequireDefault(require("./utils/getComputedStyle"));

var _hyphenateStyleName = _interopRequireDefault(require("./utils/hyphenateStyleName"));

/**
 * Gets the value for a style property
 * @param node  The DOM element
 * @param property  The style property
 * @returns The value of the style property
 */
function getStyle(node, property) {
  if (property) {
    var value = node.style[(0, _camelizeStyleName["default"])(property)];

    if (value) {
      return value;
    }

    var styles = (0, _getComputedStyle["default"])(node);

    if (styles) {
      return styles.getPropertyValue((0, _hyphenateStyleName["default"])(property));
    }
  }

  return node.style || (0, _getComputedStyle["default"])(node);
}

module.exports = exports.default;